import { Button } from 'react-bootstrap'
import YoutubeEmbed from './YoutubeEmbed'
import { useContext } from 'react'
import { Link } from 'react-router-dom'
import { AppContext } from '../context'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { DownloadModalContext } from '../pages/Home'

const HowToEnter = ({ openVideo, className }) => {
  const { setShow } = useContext(DownloadModalContext)
  const { token, timelineCompetitions } = useContext(AppContext)

  const currentVideoURL = timelineCompetitions.currentCompetition?.explicative_video
  const lastCompetitionVideoURL = timelineCompetitions.lastCompetitions[0]?.explicative_video
  const nextCompetitionVideoURL = timelineCompetitions.nextCompetition?.explicative_video

  const getIDFromURL = (url) => {
    return url ? url.split('/').pop() : null
  }

  const currentID = getIDFromURL(currentVideoURL)
  const lastCompetitionID = getIDFromURL(lastCompetitionVideoURL)
  const nextCompetitionID = getIDFromURL(nextCompetitionVideoURL)

  return (
    <section className={classNames('HowToEnter mb-0 mb-xl-5', className)} style={{maxWidth: 'max-content'}} id="how-to-enter">
      <h1 className="text-Landing fw-600 text-center mb-5">How to enter</h1>
      {timelineCompetitions.currentCompetition && !timelineCompetitions.nextCompetition && (
        <YoutubeEmbed video={`https://www.youtube.com/embed/${currentID}`} className="HowToEnter__Video" />
      )}
      {timelineCompetitions.lastCompetitions && timelineCompetitions.lastCompetitions.length !== 0 && !timelineCompetitions.nextCompetition && !timelineCompetitions.currentCompetition && (
        <YoutubeEmbed video={`https://www.youtube.com/embed/${lastCompetitionID}`} className="HowToEnter__Video" />
      )}
      {timelineCompetitions.nextCompetition && (
        <YoutubeEmbed video={`https://www.youtube.com/embed/${nextCompetitionID}`} className="HowToEnter__Video" />
      )}
      <div className="HowToEnter__Info">
        <div className="d-flex gap-4">
          <div className="d-flex flex-column gap-2">
            <p className="caption-2">1. Download</p>
            <p className="mb-0 fw-400 ffam-FreeSans" style={{fontSize: '18px'}} >
              Your video must include the <strong>Outback Explorer Competition</strong> sticker.
              <br />
              Place sticker on top for the duration of the video.
            </p>
            <Button
              id="Step1-Download-Btn-Btn"
              variant={'rs'}
              className="HowToEnter__Button px-0 px-md-5 mt-2"
              onClick={() => setShow(true)}
            >
              Download sticker
            </Button>

            <div className="HowToEnter__CreateBox position-relative my-3">
              <p className="fw-bold text-3 ffam-FreeSans">
                To add the sticker on your Instagram video:
              </p>
              <p className="mb-0 text-3 ffam-FreeSans">
                1. Press the <strong>sticker emoji</strong> (second from the left).
              </p>
              <p className="mb-0 text-3 ffam-FreeSans">
                2. Select the <strong>&apos;cutouts&apos;</strong> or <strong>&apos;photos&apos;</strong> and choose the Outback Explorer Sticker.
              </p>
              <p className="text-3 ffam-FreeSans">
                3. The sticker should appear over your video. Arrange it so it is well positioned and readable. Please see example video for reference.
              </p>
            </div>

            <div className="HowToEnter__CreateBox position-relative my-3">
              <p className="fw-bold text-3 ffam-FreeSans">
                To add the sticker on your TikTok video:
              </p>
              <p className="mb-0 text-3 ffam-FreeSans">
                1. Press the <strong>sticker emoji</strong> (four from the top).
              </p>
              <p className="mb-0 text-3 ffam-FreeSans">
                2. Select <strong>&apos;photos&apos;</strong> button around halfway down your screen on the left and select the Outback Explorer Competition sticker.
              </p>
              <p className="text-3 ffam-FreeSans">
                3. The sticker will appear very small in the middle of the screen. Arrange it so it is well positioned and readable. Please see example video for reference.
              </p>
            </div>
          </div>
        </div>
        <div className="d-flex gap-4">
          <div className="d-flex flex-column gap-1">
            <p className="caption-2">2. Create</p>
            <p className="mb-0 fw-400 ffam-FreeSans" style={{fontSize: '18px'}}>
              Post your video on Instagram, YouTube or TikTok.
            </p>
          </div>
        </div>
        <div className="d-flex gap-4">
          <div className="d-flex flex-column gap-1">
            <p className="caption-2">3. Upload</p>
            <p className="mb-0 fw-400 ffam-FreeSans" style={{fontSize: '18px'}}>
              Submit your video for entry by completing the form below.
            </p>
            <div className="HowToEnter__CreateBox position-relative my-3">
              <p className="fw-bold text-3 ffam-FreeSans">
                If posting from Instagram or TikTok
              </p>
              <p className="mb-0 text-3 ffam-FreeSans">
                1. Set your account to <strong>public</strong>.
              </p>
              <p className="mb-0 text-3 ffam-FreeSans">
                2. Use <strong>original audio</strong> only.
              </p>
              <p className="text-3 ffam-FreeSans">
                3. Use <strong>portrait</strong> aspect ratio.
              </p>
              <p className="mb-0 fw-400 ffam-FreeSans text-3" >
                This ensures your video is viewable on the Outback Explorer Competition website.
              </p>
            </div>
          </div>
        </div>
        <div className="d-flex gap-4">
          <div className="d-flex flex-column gap-1">
            <p className="caption-2">4. Share & vote</p>
            <p className="mb-0 fw-400 ffam-FreeSans" style={{fontSize: '18px'}}>
              Once uploaded, use the <strong>Share Video</strong> function <strong>to get more votes</strong> and to increase your chances of <strong>winning $1,000 cash</strong>.
            </p>
            <p className="mb-0 fw-400 ffam-FreeSans" style={{fontSize: '18px'}}>
              You have 1 vote to use every day.
            </p>
            <p className="mb-0 fw-400 ffam-FreeSans" style={{fontSize: '18px'}}>
              No account is needed to vote, but creating an account <strong>gives you 5 votes per day</strong>.
            </p>
            {!token ? (
              <Link to="/register">
                <Button
                  id="Step4-Create-Account-Btn"
                  variant={'rs'}
                  className="HowToEnter__Button px-5 mt-2"
                >
                  Create voting account
                </Button>
              </Link>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

HowToEnter.propTypes = {
  openVideo: PropTypes.func.isRequired,
  className: PropTypes.string,
}

export default HowToEnter
